export { default as JSObject } from './JSObject'; // 对象操作
export { default as JSString } from './JSString'; // 字符串操作


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/utils/kit/index.ts